import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  z-index: 2;
  right: 1vh;
  cursor: pointer;
  top: 1vh;
  svg{
    width: 3vh;
    fill: rgb(255 255 255);
    height: 3vh;
  }
`;